__turbopack_context__.v({
  "body": "SideMenu-module__1Ta_NG__body",
  "label": "SideMenu-module__1Ta_NG__label",
  "rightSection": "SideMenu-module__1Ta_NG__rightSection",
  "root": "SideMenu-module__1Ta_NG__root",
  "section": "SideMenu-module__1Ta_NG__section",
});
